import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-12 px-4" data-id="element-187">
      <div className="max-w-3xl mx-auto text-center" data-id="element-188">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-8" data-id="element-189">
          Si sos profe de tenis,{' '}
          <span className="text-[#00B4D8]" data-id="element-190">esto te suena:</span>
        </h2>

        <div className="space-y-3 text-left mb-10" data-id="element-191">
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-3 sm:p-4" data-id="element-192">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-193">❌</span>
            <p className="text-white text-sm sm:text-base font-medium" data-id="element-194">
              Llegás a la cancha improvisando sin un plan claro
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-3 sm:p-4" data-id="element-195">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-196">❌</span>
            <p className="text-white text-sm sm:text-base font-medium" data-id="element-197">
              Tus alumnos no progresan porque no hay secuencia de niveles
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-3 sm:p-4" data-id="element-198">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-199">❌</span>
            <p className="text-white text-sm sm:text-base font-medium" data-id="element-200">
              El 60% abandona antes del año y no sabés cómo frenarlo
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-3 sm:p-4" data-id="element-201">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-202">❌</span>
            <p className="text-white text-sm sm:text-base font-medium" data-id="element-203">
              Mezclás edades y niveles en la misma clase y es un caos
            </p>
          </div>
          <div className="flex items-center gap-3 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-3 sm:p-4" data-id="element-204">
            <span className="text-[#FF0000] text-xl flex-shrink-0" data-id="element-205">❌</span>
            <p className="text-white text-sm sm:text-base font-medium" data-id="element-206">
              No podés cobrar más porque no tenés un sistema profesional
            </p>
          </div>
        </div>

        <p className="text-[#00B4D8] text-xl sm:text-2xl font-black mb-6" data-id="element-207">
          ¿Cuántas clases más vas a improvisar?
        </p>

        <div className="h-px bg-gradient-to-r from-transparent via-[#00B4D8] to-transparent w-full" data-id="element-208" />
      </div>
    </section>;
}